module.exports = __webpack_public_path__ + "static/media/web developer.c53fb865.png";